var map = {
	"./dancing_panda1.gif": "4aa6",
	"./dancing_panda2.gif": "1474",
	"./dancing_panda3.gif": "2f74",
	"./dancing_panda4.gif": "8c76",
	"./sad_panda1.gif": "95b9",
	"./sad_panda2.gif": "c12c",
	"./sad_panda3.gif": "60d6",
	"./sad_panda4.gif": "d564",
	"./thinking_panda1.gif": "3495",
	"./thinking_panda2.gif": "7b17",
	"./thinking_panda3.gif": "4988",
	"./thinking_panda4.gif": "1223"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c8d";